// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { getPrivateListsService, ImportPrivateListsModal } from "@keller/App/Services/ImportPrivateListsService";

type HandlerType = ApiHandler<
    HasOnSuccess<ImportPrivateListsModal> & HasOnError<string>,
    ServiceResult<ImportPrivateListsModal>
>;

export const RequestApi: HandlerType = async props => {
    props.apiResult = await getPrivateListsService();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const LoadSession: HandlerType = props => {
    if (props.apiResult.successful && props.apiResult.result.importedListsCount) {
        props.dispatch({
            type: "Data/WishLists/Reset",
        });
        setTimeout(() => props.dispatch(loadSession()), 3000);
    }
};

export const chain = [RequestApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback, LoadSession];

const importPrivateLists = createHandlerChainRunner(chain, "importPrivateLists");
export default importPrivateLists;
